<template>
  <el-tabs class="transportation" v-model="activeName">
    <el-tab-pane label="组织架构" name="corporateProfile">
      <Team v-if="activeName == 'corporateProfile'"></Team>
    </el-tab-pane>
    <el-tab-pane label="物流明星" name="position">
      <LogisticsStar v-if="activeName == 'position'"></LogisticsStar>
    </el-tab-pane>
    <el-tab-pane label="配送及时率" name="timeliness">
      <timeliness v-if="activeName == 'timeliness'" />
    </el-tab-pane>
    <el-tab-pane label="物流减排" name="culture">
      <LogisticsEmission v-if="activeName == 'culture'"></LogisticsEmission>
    </el-tab-pane>
    <el-tab-pane label="物流安全" name="logisticssafety">
      <logisticssafety v-if="activeName == 'logisticssafety'" />
    </el-tab-pane>
    <el-tab-pane label="车辆里程" name="product">
      <CarMale v-if="activeName == 'product'"></CarMale>
    </el-tab-pane>
    <el-tab-pane label="车辆类型" name="vehicletype">
      <vehicletype v-if="activeName == 'vehicletype'" />
    </el-tab-pane>
    <el-tab-pane label="车辆状态" name="team">
      <CarStatus v-if="activeName == 'team'"></CarStatus>
    </el-tab-pane>
    <el-tab-pane label="人员状态" name="statepersonnel">
      <statepersonnel v-if="activeName == 'statepersonnel'" />
    </el-tab-pane>
    <el-tab-pane label="物流提示" name="honor">
      <LogisticsReminder v-if="activeName == 'honor'"></LogisticsReminder>
    </el-tab-pane>
  </el-tabs>
</template>
<script>
import timeliness from './timeliness'
import vehicletype from './vehicletype'
import statepersonnel from './statepersonnel'
import logisticssafety from './logisticssafety'

import Team from './team'
import LogisticsStar from './logisticsStar'
import LogisticsEmission from './logisticsEmission'
import CarMale from './carMale'
import CarStatus from './carStatus'
import LogisticsReminder from './logisticsReminder'
export default {
  components: {
    LogisticsStar,LogisticsEmission,CarMale,CarStatus,LogisticsReminder,Team,
    timeliness,
    vehicletype,
    statepersonnel,
    logisticssafety,
  },
  data() {
    return {
      activeName: 'corporateProfile',
    }
  },
  mounted() {},
  methods: {

  },
}
</script>

<style lang="less">
.transportation{
  .trend-title{ display: inline-block; width: 6rem; text-align: right; height: 1.8rem; padding:0 .8rem; vertical-align: top; line-height: 1.8rem; font-size: .8rem; background: #3570ff;}
  .avatar,.avatar-uploader{ width: 8rem; height: 6rem; border: #3570ff solid 1px; vertical-align: top;}
  .avatar-uploader{ color: #fff; text-align:center; line-height: 6rem; font-size: 2rem; vertical-align: top;}
  .last-save{ margin-top: 2rem;}
}
</style>